export default __webpack_public_path__ + "static/media/hat.b6022cd4.png";